import React from "react";
import { MapPin } from "lucide-react";
import { serviceAreas } from "../mock";

const ServiceArea = () => {
  const items = [...serviceAreas, ...serviceAreas];

  return (
    <section id="area" className="py-20 lg:py-24 bg-black border-y border-red-900/30 relative overflow-hidden">
      <div className="absolute inset-0 fire-bg-subtle opacity-70 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-yellow-400 font-bold uppercase tracking-[0.3em] text-xs">Service Area</span>
          <h2 className="mt-3 text-white font-extrabold text-3xl lg:text-5xl tracking-tight heading-underline">
            Louisa, KY &amp; the Tri-State
          </h2>
          <p className="mt-6 text-zinc-400 text-lg leading-relaxed">
            Based in Louisa and on the road throughout Eastern Kentucky, southern Ohio, and western West Virginia. Not sure if I cover you? Just call.
          </p>
        </div>

        <div className="mt-12 overflow-hidden">
          <div className="marquee-track gap-3">
            {items.map((city, i) => (
              <div key={i} className="shrink-0 inline-flex items-center gap-2 px-5 py-3 rounded-full border border-red-700/40 bg-red-950/30 text-white text-sm font-semibold">
                <MapPin className="w-4 h-4 text-yellow-400" />
                {city}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;
